import { Box, Button, Typography } from "@mui/material"
import { MapIssueLog, MapMappingPlanFeature, MapMappingPlanRole, MapMappingReportCategory, MapMappingRoleFeatures } from "../../../components/Table/mapping-function/TableMapping";
import { PackageTable } from "../../../components/Table/component/PackageTable";
import { useState } from "react";
import { ComponentTopBtn } from "../../../components/public/Button";
import { Link } from "react-router-dom";
export const Mapping = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [tableRoleFeature, setTableRoleFeature] = useState(MapMappingRoleFeatures(new Array(Math.round(Math.random() * (5000 - 5 + 1)) + 5).fill(4)));
    const [tablePlanRole, setTablePlanRole] = useState(MapMappingPlanRole(new Array(Math.round(Math.random() * (5000 - 5 + 1)) + 5).fill(4)));
    const [tableReportCategory, setTableReportCategory] = useState(MapMappingReportCategory(new Array(Math.round(Math.random() * (5000 - 5 + 1)) + 5).fill(4)));
    const [tablePlanFeature, setTablePlanFeature] = useState(MapMappingPlanFeature(new Array(Math.round(Math.random() * (5000 - 5 + 1)) + 5).fill(4)));
    const [tab, setTab] = useState(0);
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const tabBtns = ['Role Feature', 'Plan Role - Report', 'Report - Category', 'Plan Feature']
    const tbl = () => {
        switch (tab) {
            case 0: return tableRoleFeature
            case 1: return tablePlanRole
            case 2: return tableReportCategory
            case 3: return tablePlanFeature
            default: return []
        }
    }

    const prop = {
        // title: 'Issue Log',
        borderBoxStyle: { px: 0 },
        goto: true,
        // searchTerm,
        // setSearchTerm,
        filteredData: tbl(),
        titleStyle: { fontSize: '20px', fontWeight: '600', color: '#000' },
        tableStyle: { OutBox: { borderRadius: "8px", borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }, },
        rowsPerPage,
        page,
        setPage
    }
    return (
        <Box sx={{ width: '100%', }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography sx={{ color: '#000000', fontSize: '20px', fontWeight: '600' }}>Mapping</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                    <Link to={`/admin/separate-mapping?tab=${encodeURIComponent(tab)}&tabName=${encodeURIComponent(tabBtns[tab] + ' Mapping')}`} state={{ tab: tab, tabName: tabBtns[tab] + ' Mapping' }}>
                        <Button disableRipple sx={{ textTransform: 'capitalize', minHeight: 'max-content', minWidth: 'max-content', height: '26px', width: '64px', background: '#FF2800', color: '#fff', '&:hover': { background: '#FF2800' }, }}>Mapping</Button>
                    </Link>
                </Box>
            </Box>
            <Box>
                {tabBtns?.map((e, i) => (<ComponentTopBtn btn={{ name: e, tab, setTab, i: i, first: i === 0, last: i === tabBtns.length - 1, btnStyl: { border: 'none', borderTopLeftRadius: { xs: '8px', md: '8px' }, borderTopRightRadius: { xs: '8px', md: '8px' }, } }} />))}
            </Box>
            <PackageTable prop={prop} />
        </Box>
    )
}